export const enLang = {
  contact: 'Contact',
  people: 'Team',
  ourPractice: 'Our Practice',
  ourFirm: 'Our Firm'
};

export default enLang;
